import { DateTime } from "luxon";
import { TripX, Activity, Location } from "@/types/trip";

interface CalendarItem {
  id: string | number;
  name: string;
  start_time: string;
  timezone: string;
  categories?: string[];
  type?: string;
  waytora_id?: string;
  viator_id?: string;
}

interface ReturnType {
  date: string;
  items: CalendarItem[];
}

export const useAllTripItineraryItems = (
  trip: TripX | null,
  options: {
    includeLodging: boolean;
    includeFlights: boolean;
  }
): ReturnType[] => {
  const returnArray: ReturnType[] = [];
  if (!trip) return returnArray;

  // Helper function to add item to the correct date group
  const addItemToDate = (item: CalendarItem) => {
    const localDateTime = DateTime.fromISO(item.start_time, {
      zone: item.timezone,
    });
    const formattedDate = localDateTime.toFormat("yyyy-MM-dd");

    const existingDayIndex = returnArray.findIndex(
      (day) => day.date === formattedDate
    );

    if (existingDayIndex === -1) {
      returnArray.push({
        date: formattedDate,
        items: [item],
      });
    } else {
      // Add null check to handle potential undefined index
      if (returnArray[existingDayIndex]) {
        returnArray[existingDayIndex].items.push(item);
      }
    }
  };

  const locations = trip.locations;

  // Collect all itinerary items from each location
  locations.forEach((location) => {
    location.itinerary_items.forEach((dayItems) => {
      dayItems.items.forEach((item) => {
        if (!item.start_time) return;

        const formattedItem = {
          id: item.id,
          name: item.name,
          start_time: item.start_time,
          timezone: location.date.time_zone,
          categories: item.categories || [],
          type: item.type,
        };

        addItemToDate(formattedItem);
      });
    });

    // Update lodging handling
    if (options.includeLodging && location.accommodation.main) {
      const lodging = location.accommodation.main;
      if (lodging.policies?.checkIn) {
        const lodgingItem = {
          id: lodging.id,
          name: lodging.name,
          start_time: lodging.policies.checkIn,
          timezone: location.date.time_zone,
          type: "hotel",
          categories: ["Accommodation"],
        };

        addItemToDate(lodgingItem);
      }
    }
  });

  // // Update flight handling
  // if (options.includeFlights && trip.transport) {
  //   trip.flights.forEach((flight) => {
  //     logger.log("flight", flight);
  //     const fromLocation = locations.find(
  //       (loc) => loc.id === flight.fromLocationId
  //     );

  //     if (fromLocation) {
  //       logger.log("flight", flight);
  //       const flightItem = {
  //         id: flight.id,
  //         name: `Flight to ${flight.to.city}`,
  //         start_time: flight.departure_utc,
  //         timezone: fromLocation.date.time_zone,
  //         type: "flight",
  //         categories: ["Transport"],
  //       };

  //       addItemToDate(flightItem);
  //     }
  //   });
  // }

  // Sort arrays
  returnArray.sort((a, b) => a.date.localeCompare(b.date));
  returnArray.forEach((day) => {
    day.items.sort((a, b) => {
      if (!a.start_time) return 1;
      if (!b.start_time) return -1;
      return (
        DateTime.fromISO(a.start_time).toMillis() -
        DateTime.fromISO(b.start_time).toMillis()
      );
    });
  });

  return returnArray;
};
